import axios from "axios";
import $snackbar from "@/core/ui/snackbar";
import $user from "@/core/user/store";

const instance = axios.create({
  baseURL: "/api/v1",
});

instance.interceptors.response.use(
  function (response) {
    if (response.config.method === "put") {
      $snackbar.open("Изменения сохранены");
    }
    return response.data;
  },
  function (error) {
    if (!error.response) {
      $snackbar.open("Сервер недоступен", "error");
      return Promise.reject(error);
    }

    const { status, data } = error.response;
    const message = data && data.message;

    if (status === 401) {
      $user.reset();
      return Promise.reject(error);
    }

    if (status === 409) {
      $snackbar.open(
        message || "Данные устарели, перезагрузите страницу",
        "warning"
      );
      return Promise.reject(error);
    }

    $snackbar.open(message || "Произошла ошибка", "error");
    return Promise.reject(error);
  }
);

export function GET(url, query, config = {}) {
  return instance.get(url, { params: query, ...config });
}

export function POST(url, data, config) {
  return instance.post(url, data, config);
}

export function PUT(url, data, config) {
  return instance.put(url, data, config);
}

export function DEL(url) {
  return instance.delete(url);
}
